:host {
  display: block;
}

h2 {
  color: rgb(46, 82, 118);
  font-size: 44px;
  font-family: 'acumin-pro', Helvetica, Arial, sans-serif;
  font-weight: 500;
  letter-spacing: -0.5px;
  line-height: 61px;
}
